"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _defaultTheme = _interopRequireDefault(require("../defaultTheme"));
var _getViewportHideStyles = _interopRequireDefault(require("./helpers/getViewportHideStyles"));
var _getDisplay = _interopRequireDefault(require("./helpers/getDisplay"));
const StyledHide = _styledComponents.default.div.withConfig({
  displayName: "Hide__StyledHide",
  componentId: "sc-1ilbsf3-0"
})(["", ";"], ({
  $on
}) => (0, _getViewportHideStyles.default)($on, _getDisplay.default));
StyledHide.defaultProps = {
  theme: _defaultTheme.default
};
const Hide = ({
  on = [],
  block,
  children
}) => /*#__PURE__*/React.createElement(StyledHide, {
  $on: on,
  $block: block
}, children);
var _default = Hide;
exports.default = _default;